<template>
  <div id="app" class="APP bg-gray-50">
    <div class="flex h-screen overflow-hidden">
      <Split>
        <SplitArea :size="sidebarSize" :minSize="0">
          <SidebarDesktop></SidebarDesktop>
        </SplitArea>
        <SplitArea :size="mainPanelSize">
          <SidebarMobile ref="sidebar"></SidebarMobile>
          <MainPanel @open-sidebar="openSidebar"></MainPanel>
        </SplitArea>
      </Split>
    </div>

    <PriceModal v-if="showNewPriceModal"
                @save-price="createPrice"
                @price-imported="importPrice"
                @close="showNewPriceModal = false"></PriceModal>
    <PriceModal v-if="showEditPriceModal"
                :price="price"
                @save-price="editPrice"
                @close="showEditPriceModal = false"></PriceModal>
    <NewFolderModal v-if="showNewFolderModal"></NewFolderModal>

    <div v-if="settings.debug.showJsonModels">
      <h1>Prices:</h1>
      <pre>
        {{ prices }}
      </pre>
      <hr/>
      <h1>Settings:</h1>
      <pre>
        {{ settings }}
      </pre>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import SidebarMobile from '@/components/sidebar/SidebarMobile'
import SidebarDesktop from '@/components/sidebar/SidebarDesktop'
import MainPanel from '@/components/MainPanel'
import PriceModal from '@/components/modals/PriceModal'
import NewFolderModal from '@/components/modals/NewFolderModal'
import { makeid } from '@/helpers'

export default {
  name: 'App',
  components: {
    SidebarMobile,
    SidebarDesktop,
    MainPanel,
    PriceModal,
    NewFolderModal
  },
  data(){
    return {
      showNewPriceModal: false,
      showNewFolderModal: false,
      showEditPriceModal: false,
      priceToDuplicate: null,
      isPortrait: false
    }
  },
  computed: {
    ...mapGetters('settings', {
      settings: 'settings'
    }),
    ...mapGetters('prices', {
      prices: 'prices',
      price: 'price'
    }),
    sidebarSize(){
      return this.isPortrait ? 0 : 20
    },
    mainPanelSize(){
      return this.isPortrait ? 99 : 80
    }
  },
  methods: {
    ...mapActions('prices', {
      setPrice: 'setPrice'
    }),
    newPrice(){
      this.showNewPriceModal = true
      this.$refs.sidebar.close()
    },
    newFolder(){
      this.showNewFolderModal = true
      this.$refs.sidebar.close()
    },
    closeNewPriceModal(){
      this.showNewPriceModal = false
    },
    closeNewFolderModal(){
      this.showNewFolderModal = false
    },
    assignPriceIdToRows(parent){
      parent.rows.forEach(row => {
        row.price_id = parent.price_id ? parent.price_id : parent.id
        if(row.rows){
          this.assignPriceIdToRows(row)
        }
      })
    },
    createPrice(name){
      if(this.priceToDuplicate){

        let clone = JSON.parse(JSON.stringify(this.priceToDuplicate))
        this.priceToDuplicate = null
        clone.id = makeid(4)
        clone.name = name

        this.assignPriceIdToRows(clone)

        this.$store.dispatch('prices/addPrice', clone)
        this.closeNewPriceModal()
        this.$router.push({ name: 'price', params: { priceid: clone.id }})

      }else{

        let newPrice = {
          id: makeid(4),
          name: name,
          rows: [],
          tax: this.settings.tax,
          markup: this.settings.markup
        }
        this.$store.dispatch('prices/addPrice', newPrice)
        this.closeNewPriceModal()
        this.$router.push({ name: 'price', params: { priceid: newPrice.id }})
      }

    },
    importPrice(price){
      const id = makeid(4)
      Vue.set(price, 'id', id)
      this.$store.dispatch('prices/addPrice', price)
      this.closeNewPriceModal()
      this.$router.push({ name: 'price', params: { priceid: id }})
    },
    editPrice(price){
      this.$store.dispatch('prices/updatePrice', price)
      this.showEditPriceModal = false
    },
    duplicatePrice(price){
      this.showNewPriceModal = true
      this.priceToDuplicate = price
    },
    deletePrice(price){
      this.$store.dispatch('prices/deletePrice', price.id)
      this.$router.push({ name: 'home' })
    },
    createFolder(folder){
      let newFolder = {
        id: makeid(4),
        name: folder.name
      }

      this.$store.dispatch('folder/addFolder', newFolder)
      this.closeNewPriceModal()
    },
    openSidebar() {
      this.$refs.sidebar.open()
    },
    editPriceName(){
      this.showEditPriceModal = true
    },
    windowResized(){
      if(window.innerWidth < 768){
        this.isPortrait = true
      }else{
        this.isPortrait = false
      }
    }
  },
  mounted(){
    this.$root.$on('new-price', this.newPrice)
    this.$root.$on('new-folder', this.newFolder)
    this.$root.$on('close-new-folder-modal', this.closeNewfolderModal)
    this.$root.$on('duplicate-price', this.duplicatePrice)
    this.$root.$on('delete-price', this.deletePrice)
    this.$root.$on('edit-price-name', this.editPriceName)

    window.addEventListener('resize', this.windowResized)
    this.windowResized()

    this.$store.dispatch('prices/loadDefaultPrices')
  },
  beforeDestroy(){
    this.$root.$off('new-price', this.newPrice)
    this.$root.$off('new-folder', this.newFolder)
    this.$root.$off('close-new-folder-modal', this.closeNewfolderModal)
    this.$root.$off('duplicate-price', this.duplicatePrice)
    this.$root.$off('delete-price', this.deletePrice)
    this.$root.$off('edit-price-name', this.editPriceName)

    window.removeEventListener('resize', this.windowResized)
  }
}
</script>

<style>
</style>
